import { render, staticRenderFns } from "./TemplatesDialog.vue?vue&type=template&id=74160360&scoped=true"
import script from "./TemplatesDialog.vue?vue&type=script&lang=js"
export * from "./TemplatesDialog.vue?vue&type=script&lang=js"
import style0 from "./TemplatesDialog.vue?vue&type=style&index=0&id=74160360&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74160360",
  null
  
)

export default component.exports